import insuranceStore from './store'

export { default as useInsuranceStore } from './store'

export default insuranceStore
